import { useEffect } from 'react';
import { getStakeholder, getCustomerMarking, getDfimStatus } from '../helpers/shared';
import { useConfigContext } from '../context/ConfigContext';
import { useLoggerContext } from '../context/LoggerContext';
import { useStateValue } from './UseStateValue';
import { SET_RELOAD_STAKEHOLDER } from '../store/ActionKeys';

export const useLoggedInCustomerStatus = () => {
    const [{ reloadStakeholder }, dispatch] = useStateValue();
    const config = useConfigContext();
    const { logGetCustomerMarkingError, logGetStakeholderError } = useLoggerContext();

    useEffect(() => {
        // userContext cannot be used here
        if (window.topContext.user.isLoggedOn && reloadStakeholder) {
            if (config.product === 'CAR') {
                getDfimStatus(config, dispatch);
            }
            dispatch({ type: SET_RELOAD_STAKEHOLDER, payload: false });
            (async () => {
                await getCustomerMarking({ dispatch, config }).catch((error: any) => {
                    logGetCustomerMarkingError(error.message);
                });
                await getStakeholder({ config, dispatch }).catch((error: any) => {
                    logGetStakeholderError(error.message);
                });
            })();
        }
    }, [dispatch, config, reloadStakeholder, logGetCustomerMarkingError, logGetStakeholderError]);
};
